import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../Context/AuthContext';

const useSidebar = () => {
    const { user, logout } = useAuthContext();
    const mobilemenu = useRef();
    const main = useRef();
 
    const mobilemenumain = useRef();
    const location = useLocation();

    useOutSide(mobilemenumain, () => {
        closemenu()
    })
    const openmenu = () => {
        mobilemenu.current.style.right = '0%'
        mobilemenumain.current.style.right = '0%'
    }


    useEffect(() => {
        closemenu()
        document.querySelectorAll('.item-sidebar').forEach((element) => {
            if (element.getAttribute('href')) {
                if (element.getAttribute('href') === location.pathname) {
                    element.className = "active " + element.className;
                    document.querySelector('#title-page').innerHTML = element.querySelector('.label-sidebar-item').innerHTML
                } else {
                    element.className = "item item-sidebar"
                }
            }
        })

    }, [location])

    const closemenu = () => {
        mobilemenu.current.style.right = '-100%'
        mobilemenumain.current.style.right = '-100%'
    }

    return {
        mobilemenu,
        main,
        mobilemenumain,
        openmenu,
        closemenu,
        user,
        logout
    }
}

function useOutSide(ref, action) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                action();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}
export default useSidebar